// Verbkonjugationen für alle unterstützten Sprachen
export const verbConjugations = {
  // Deutsche Verben
  de: {
    haben: {
      infinitive: 'haben',
      meaning: 'to have',
      present: {
        ich: 'habe',
        du: 'hast',
        'er/sie/es': 'hat',
        wir: 'haben',
        ihr: 'habt',
        sie: 'haben'
      },
      past: {
        ich: 'hatte',
        du: 'hattest',
        'er/sie/es': 'hatte',
        wir: 'hatten',
        ihr: 'hattet',
        sie: 'hatten'
      },
      perfect: {
        ich: 'habe gehabt',
        du: 'hast gehabt',
        'er/sie/es': 'hat gehabt',
        wir: 'haben gehabt',
        ihr: 'habt gehabt',
        sie: 'haben gehabt'
      }
    },
    sein: {
      infinitive: 'sein',
      meaning: 'to be',
      present: {
        ich: 'bin',
        du: 'bist',
        'er/sie/es': 'ist',
        wir: 'sind',
        ihr: 'seid',
        sie: 'sind'
      },
      past: {
        ich: 'war',
        du: 'warst',
        'er/sie/es': 'war',
        wir: 'waren',
        ihr: 'wart',
        sie: 'waren'
      },
      perfect: {
        ich: 'bin gewesen',
        du: 'bist gewesen',
        'er/sie/es': 'ist gewesen',
        wir: 'sind gewesen',
        ihr: 'seid gewesen',
        sie: 'sind gewesen'
      }
    },
    gehen: {
      infinitive: 'gehen',
      meaning: 'to go',
      present: {
        ich: 'gehe',
        du: 'gehst',
        'er/sie/es': 'geht',
        wir: 'gehen',
        ihr: 'geht',
        sie: 'gehen'
      },
      past: {
        ich: 'ging',
        du: 'gingst',
        'er/sie/es': 'ging',
        wir: 'gingen',
        ihr: 'gingt',
        sie: 'gingen'
      },
      perfect: {
        ich: 'bin gegangen',
        du: 'bist gegangen',
        'er/sie/es': 'ist gegangen',
        wir: 'sind gegangen',
        ihr: 'seid gegangen',
        sie: 'sind gegangen'
      }
    }
  },
  // Englische Verben
  en: {
    have: {
      infinitive: 'have',
      meaning: 'haben',
      present: {
        I: 'have',
        you: 'have',
        'he/she/it': 'has',
        we: 'have',
        you_plural: 'have',
        they: 'have'
      },
      past: {
        I: 'had',
        you: 'had',
        'he/she/it': 'had',
        we: 'had',
        you_plural: 'had',
        they: 'had'
      },
      perfect: {
        I: 'have had',
        you: 'have had',
        'he/she/it': 'has had',
        we: 'have had',
        you_plural: 'have had',
        they: 'have had'
      }
    },
    be: {
      infinitive: 'be',
      meaning: 'sein',
      present: {
        I: 'am',
        you: 'are',
        'he/she/it': 'is',
        we: 'are',
        you_plural: 'are',
        they: 'are'
      },
      past: {
        I: 'was',
        you: 'were',
        'he/she/it': 'was',
        we: 'were',
        you_plural: 'were',
        they: 'were'
      },
      perfect: {
        I: 'have been',
        you: 'have been',
        'he/she/it': 'has been',
        we: 'have been',
        you_plural: 'have been',
        they: 'have been'
      }
    }
  },
  // Französische Verben
  fr: {
    avoir: {
      infinitive: 'avoir',
      meaning: 'to have',
      present: {
        je: 'ai',
        tu: 'as',
        'il/elle': 'a',
        nous: 'avons',
        vous: 'avez',
        ils: 'ont'
      },
      past: {
        je: 'avais',
        tu: 'avais',
        'il/elle': 'avait',
        nous: 'avions',
        vous: 'aviez',
        ils: 'avaient'
      },
      perfect: {
        je: 'ai eu',
        tu: 'as eu',
        'il/elle': 'a eu',
        nous: 'avons eu',
        vous: 'avez eu',
        ils: 'ont eu'
      }
    },
    être: {
      infinitive: 'être',
      meaning: 'to be',
      present: {
        je: 'suis',
        tu: 'es',
        'il/elle': 'est',
        nous: 'sommes',
        vous: 'êtes',
        ils: 'sont'
      },
      past: {
        je: 'étais',
        tu: 'étais',
        'il/elle': 'était',
        nous: 'étions',
        vous: 'étiez',
        ils: 'étaient'
      },
      perfect: {
        je: 'ai été',
        tu: 'as été',
        'il/elle': 'a été',
        nous: 'avons été',
        vous: 'avez été',
        ils: 'ont été'
      }
    }
  }
};

export const quizData = {
  1: { // Story ID
    questions: [
      {
        id: 1,
        type: 'multiple_choice',
        question: 'Was bedeutet "Scheune" auf Englisch?',
        options: ['Barn', 'House', 'Farm', 'Field'],
        correct: 0,
        explanation: 'Eine Scheune ist ein landwirtschaftliches Gebäude zur Lagerung.'
      },
      {
        id: 2,
        type: 'fill_blank',
        question: 'In ländlichen Gegenden ist es bei reichen Leuten beliebt, eine Party-______ zu haben.',
        correct: 'Scheune',
        explanation: 'Eine Party-Scheune ist eine umgebaute Scheune für Feiern.'
      },
      {
        id: 3,
        type: 'verb_conjugation',
        question: 'Konjugieren Sie "haben" in der 1. Person Singular Präsens:',
        verb: 'haben',
        person: 'ich',
        tense: 'present',
        correct: 'habe'
      },
      {
        id: 4,
        type: 'translation',
        question: 'Übersetzen Sie: "They renovated the barns to have more space."',
        correct: 'Sie renovierten die Scheunen, um mehr Platz zu haben.',
        alternatives: ['Sie haben die Scheunen renoviert, um mehr Raum zu haben.']
      }
    ]
  }
};

export const keywordsData = {
  1: { // Story ID
    keywords: [
      {
        word: 'Scheune',
        translation: 'barn',
        definition: 'Ein landwirtschaftliches Gebäude zur Lagerung von Getreide, Heu oder zur Unterbringung von Tieren.',
        category: 'Substantiv',
        level: 'B1',
        examples: [
          'Die alte Scheune wurde zu einem Veranstaltungsort umgebaut.',
          'In der Scheune lagern wir das Heu für den Winter.'
        ],
        related: ['Stall', 'Bauernhof', 'Landleben']
      },
      {
        word: 'beliebt',
        translation: 'popular',
        definition: 'Von vielen Menschen geschätzt oder gemocht.',
        category: 'Adjektiv',
        level: 'A2',
        examples: [
          'Dieses Restaurant ist sehr beliebt bei den Einheimischen.',
          'Sie ist eine beliebte Lehrerin.'
        ],
        related: ['populär', 'geschätzt', 'gern gesehen']
      },
      {
        word: 'renovieren',
        translation: 'to renovate',
        definition: 'Ein Gebäude oder einen Raum erneuern und modernisieren.',
        category: 'Verb',
        level: 'B2',
        examples: [
          'Wir renovieren unser Haus seit drei Monaten.',
          'Die alte Kirche wurde vollständig renoviert.'
        ],
        related: ['sanieren', 'modernisieren', 'erneuern']
      },
      {
        word: 'ländlich',
        translation: 'rural',
        definition: 'Zum Land gehörend, nicht städtisch.',
        category: 'Adjektiv',
        level: 'B1',
        examples: [
          'Sie leben in einer ländlichen Gegend.',
          'Das ländliche Leben ist sehr ruhig.'
        ],
        related: ['dörflich', 'bäuerlich', 'Landleben']
      }
    ]
  }
};

export const grammarExplanations = {
  1: { // Story ID
    explanations: [
      {
        id: 1,
        title: 'Perfekt (Present Perfect)',
        text: 'Hast du schon einmal an eine Scheune gedacht',
        explanation: 'Das Perfekt wird gebildet mit haben/sein + Partizip II. Es drückt abgeschlossene Handlungen mit Bezug zur Gegenwart aus.',
        examples: [
          'Ich habe gedacht → I have thought',
          'Er ist gegangen → He has gone',
          'Wir haben gesehen → We have seen'
        ],
        level: 'A2'
      },
      {
        id: 2,
        title: 'Infinitiv mit "zu"',
        text: 'eine Party-Scheune zu haben',
        explanation: 'Nach bestimmten Verben und Ausdrücken steht der Infinitiv mit "zu".',
        examples: [
          'Es ist schön, dich zu sehen.',
          'Ich habe vergessen, anzurufen.',
          'Es ist wichtig, pünktlich zu sein.'
        ],
        level: 'A2'
      },
      {
        id: 3,
        title: 'Passiv (Passive Voice)',
        text: 'werden zu Orten umgebaut',
        explanation: 'Das Passiv wird mit "werden" + Partizip II gebildet. Der Fokus liegt auf der Handlung, nicht auf dem Handelnden.',
        examples: [
          'Das Haus wird gebaut → The house is being built',
          'Die Scheunen wurden renoviert → The barns were renovated',
          'Der Text wird übersetzt → The text is being translated'
        ],
        level: 'B1'
      }
    ]
  }
};